import SignaturePad from "signature_pad";

const CANVAS_TAG = "canvas";
const CANVAS_2D_CONTEXT = "2d";
const CLEAR_BTN_SELECTOR = ".clear-btn";
const CONTAINER_REQUIRED = "Container element required";
const EMPTY_STR = "";
const SIGNATURE_INPUT_CLASS = "signature-input";

function isElem(elem) {
  return elem instanceof Element;
}

function getClearBtn(elem) {
  return elem.querySelector(CLEAR_BTN_SELECTOR);
}

function hasCanvas(elem) {
  return elem.querySelector(CANVAS_TAG) !== null;
}

function isContainer(elem) {
  return isElem(elem) && hasCanvas(elem);
}

function isFunc(f) {
  return typeof f === "function";
}

function isObj(o) {
  return typeof o === "object";
}

export class SignatureInput {
  static get SIGNATURE_INPUT_CLASS() {
    return SIGNATURE_INPUT_CLASS;
  }

  constructor(container, options) {
    if (!isContainer(container)) {
      throw new Error(CONTAINER_REQUIRED);
    }

    this.canvas = container.querySelector(CANVAS_TAG);
    this.clearBtn = null;
    this.container = container;
    this.input = null;
    this.options = isObj(options) ? options : {};
    this.signature = null;

    this.attachSignature = this.attachSignature.bind(this);
    this.attachClearHandler = this.attachClearHandler.bind(this);
    this.onSign = this.onSign.bind(this);
    this.attachInput = this.attachInput.bind(this);
    this.render = this.render.bind(this);
    this.resizeCanvas = this.resizeCanvas.bind(this);
  }

  attachSignature() {
    this.signature = new SignaturePad(this.canvas, {
      onEnd: this.onSign,
    });
  }

  attachClearHandler() {
    const btn = getClearBtn(this.container);
    if (!btn) {
      return null;
    }
    btn.onclick = this.onClear.bind(this);
    this.clearBtn = btn;
  }

  onSign() {
    if (!this.input) {
      return;
    }

    const signature = this.signature;
    const value = signature.isEmpty() ? EMPTY_STR : signature.toDataURL();
    this.input.value = value;
  }

  attachInput() {
    const { validate, input } = this.options;

    if (isFunc(validate)) {
      input.validate = validate;
    }

    this.input = input;
  }

  onClear(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    this.signature.clear();

    if (this.input) {
      this.input.value = EMPTY_STR;
    }
  }

  render() {
    this.attachSignature();
    this.attachClearHandler();
    this.attachInput();
    this.resizeCanvas();
  }

  resizeCanvas() {
    const canvas = this.canvas;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext(CANVAS_2D_CONTEXT).scale(ratio, ratio);

    // XXX - signature clearing on resize has been deprecated
    // because the window resize event is overzealous on different clients
    // this.signature.clear();
    // if (this.input) {
    //   this.input.value = EMPTY_STR;
    // }
  }
}
